/* Fuego & Fragancia — Ritual builder (PRD §8.2): toggle pieces, live total, add all to cart */

if (!customElements.get('ff-ritual-builder')) {
  customElements.define(
    'ff-ritual-builder',
    class FfRitualBuilder extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('.ff-ritual-builder__row'));
        this.summaryEl = this.querySelector('[data-ff-builder-summary]');
        this.submitButton = this.querySelector('[data-ff-builder-submit]');
        this.currency = this.dataset.currency || 'USD';
        this.labelAdd = this.dataset.labelAdd || 'ADD';
        this.labelAdded = this.dataset.labelAdded || 'ADDED';
        this.summaryTemplate = this.dataset.summaryTemplate || '[count] — [total]';

        this.rows.forEach((row) => {
          const toggle = row.querySelector('.ff-ritual-builder__toggle');
          if (!toggle) return;
          toggle.addEventListener('click', () => {
            const selected = row.classList.toggle('is-selected');
            toggle.textContent = selected ? this.labelAdded : this.labelAdd;
            this.updateSummary();
          });
        });

        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.addToCart.bind(this));
        }

        this.updateSummary();
      }

      selectedRows() {
        return this.rows.filter((row) => row.classList.contains('is-selected'));
      }

      // Delegado en el ayudante compartido (ff-money.js), que usa el formato
      // de la tienda. Antes esto era un Intl.NumberFormat con el idioma de la
      // página: en inglés daba "$31.31" y en español "31,31 US$", así que el
      // precio cambiaba de forma según el idioma y no coincidía con el que
      // pinta el servidor.
      formatMoney(cents) {
        if (window.ffMoney) return window.ffMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      updateSummary() {
        const selected = this.selectedRows();
        const total = selected.reduce((sum, row) => sum + (parseInt(row.dataset.price, 10) || 0), 0);
        const count = selected.length;
        const countLabel = count === 1 ? '1 ITEM' : count + ' ITEMS';

        if (this.summaryEl) {
          this.summaryEl.textContent = this.summaryTemplate
            .replace('[count]', countLabel)
            .replace('[total]', this.formatMoney(total));
        }

        if (this.submitButton) {
          this.submitButton.disabled = count === 0;
        }
      }

      addToCart() {
        const selected = this.selectedRows();
        if (!selected.length) return;

        this.submitButton.classList.add('loading');
        this.submitButton.disabled = true;

        const items = selected.map((row) => ({ id: Number(row.dataset.variantId), quantity: 1 }));
        const cartDrawer = document.querySelector('cart-drawer');
        const body = { items: items };

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[ff-ritual-builder]', response.description || response.message);
              return;
            }
            if (cartDrawer) {
              // Igual que hace product-form.js de Dawn: sin esto la clase
              // is-empty se queda pegada y `cart-drawer.is-empty .drawer__inner`
              // convierte el panel en grid, rompiendo el carrito entero.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((error) => console.error('[ff-ritual-builder]', error))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.updateSummary();
          });
      }
    }
  );
}
